import Vue from "vue";
import queryString from "query-string";

export async function fetchServicesTypes({ commit }, filtro) {
  try {
    let ruta =Vue.prototype.$apiRoute +"tipoAutorizados/?" + queryString.stringify(filtro);
    let res = await fetch(ruta, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("_token")
      }
    });
    if (res.ok) {
      let data = await res.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return [];
  }
  //console.log("La petición para obtener los tipos de servicio ha finalizado");
}

export async function getAllServicesTypes({ commit }) {
  try {
    let ruta = Vue.prototype.$apiRoute + "tiposServicio";
    let res = await fetch(ruta, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("_token")
      }
    });
    if (res.ok) {
      let data = await res.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return [];
  }
  //console.log("La petición para obtener los tipos de servicio ha finalizado");
}
